<panel width="600">
	<h1>{{ 'company.product-plans.terminate-all.header' | translate }}</h1>
	@if (planBrands.length > 1) {
		<section>
			<custom-input inputType="radio" [(value)]="brandId">
				@for (brandId of planBrands; track brandId) {
					<radio-button [value]="brandId" label="{{ brandId | brand }}" />
				}
			</custom-input>
		</section>
	}
	<section one-column>
		<p>{{ 'company.product-plans.terminate-all.plans-to-terminate' | translate: { plansToTerminate: this.plansToTerminateNames } }}</p>
	</section>
	<section>
		<reason-select [type]="reasonType.Termination" (valueChange)="selectedTerminationReason = $event" [required]="true" />
		<date-input #terminationDateInput [label]="'company.product-plans.termination-date' | translate" [(value)]="newTerminationDate" [required]="true" [maxDate]="maxTerminationDate" />
		<custom-input [label]="'company.product-plans.end-plans-now' | translate" inputType="checkbox" [(value)]="endPlansNow" />
	</section>
	<section>
		<button ghost (click)="cancel()" [ignoreValidation]="true">{{ 'general.cancel' | translate }}</button>
		<button confirm (click)="terminateProductPlans()" [active]="!!selectedTerminationReason">{{ 'general.save' | translate }}</button>
	</section>
</panel>
